import { Container } from '@mui/system';
import React from 'react';
import DoctorItem from '../components/DoctorItem';

const DoctorsList = ({ doctors }) => {

    return (
        <Container disableGutters sx={{ px: 0 }}>
            <Container disableGutters={true}
            sx={{
                display: 'flex',
                alignItems: 'flex-start',
                flexDirection: 'row',
                flexWrap: 'wrap', 
                p: 0,
                m: 0
            }}>
                {doctors.map(doctor => 
                    <DoctorItem key={doctor.id} doctor={doctor}/>
                )}
            </Container>
        </Container>
    );
};

export default DoctorsList;
